<template>
	<div class="d-flex-column gap-2">
		<div class="d-flex gap-2">
			<div>
				<input
					class="checkbox border-xs"
					:class="[
						squared ? 'rounded-1' : 'rounded-circle',
						error ? 'border-error-500' : 'border-neutral-200',
					]"
					:id="checkboxId"
					v-model="checked"
					type="checkbox"
					style="width: 16px; height: 16px"
					@change="(event: Event) => $emit('change', event)"
				/>
			</div>
			<label
				v-if="label"
				class="text-body-m align-self-center cursor-pointer"
				v-html="label"
				:for="checkboxId"
			/>
			<slot name="label"></slot>
		</div>
		<p v-if="error" class="text-error-500 text-body-m">{{ error }}</p>
	</div>
</template>

<script lang="ts" setup>
	import { useId } from 'vue'
	interface Props {
		label?: string
		squared?: boolean
		error?: string
	}
	const checkboxId = useId()

	defineEmits(['change'])
	defineProps<Props>()
	const checked = defineModel<boolean>()
</script>

<style lang="scss" scoped>
	.checkbox {
		width: 1.3em;
		height: 1.3em;
		background-color: white;
		vertical-align: middle;
		appearance: none;
		-webkit-appearance: none;
		outline: none;
		cursor: pointer;
	}

	.checkbox:checked {
		background-color: var(--color-primary-400);
		background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='14px' height='10px' viewBox='0 0 14 10' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 59.1 (86144) - https://sketch.com --%3E%3Ctitle%3Echeck%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='ios_modification' transform='translate(-27.000000, -191.000000)' fill='%23FFFFFF' fill-rule='nonzero'%3E%3Cg id='Group-Copy' transform='translate(0.000000, 164.000000)'%3E%3Cg id='ic-check-18px' transform='translate(25.000000, 23.000000)'%3E%3Cpolygon id='check' points='6.61 11.89 3.5 8.78 2.44 9.84 6.61 14 15.56 5.05 14.5 4'%3E%3C/polygon%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
		background-size: 10px 10px;
		background-repeat: no-repeat;
		background-position: center;
	}
</style>
